export const replaceDateFormat = (date: string) =>
  date.replaceAll("d", "D").replaceAll("y", "Y")
